import React, { Component, Fragment } from "react";

import { Row, Col } from "react-bootstrap";
// services
import { DepartmentService } from "app/_services/UserManagement/DepartmentService";

// custom
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import BackBtn from "app/Components/CommanComponents/BackBtn";

export class ViewDepartment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewId: this.props.match.params.id ? this.props.match.params.id : "",
      viewData: {},
      dataModule: [],
    };
  }

  async componentDidMount() {
    await this.viewData();
  }

  /*******************Api Call *******************/

  viewData = async () => {
    let response = await DepartmentService.getDepartmentByID(this.state.viewId);
    if (response && response.status) {
      if (response.data && response.data) {
        this.setState({
          viewData: response.data,
        });
      }
    }
  };

  render() {
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            { name: "User Management", path: "#" },
            { name: "Department", path: "/user-management/department" },
            { name: "View" },
          ]}
          breadCrumbsText="User_Management_Department"
        />
        {this.state.viewData && Object.keys(this.state.viewData).length > 0 && (
          <Fragment>
            <div className="row d-flex justify-content-center">
              <div className="col-md-12">
                <div className="card mt-4 mb-3">
                  <div className="card-body">
                    <div className="simple-card-title">
                      <h3 class="text-capitalize mb-1">View Department</h3>

                      <BackBtn url="/user-management/department" />
                    </div>
                    <div
                      className="addressSmlSec"
                      style={{ paddinTop: "0", borderTop: "0" }}
                    >
                      <Row>
                        <Col md={3} className="drilingView-bx">
                          <h5>Department Name</h5>
                          <p>{this.state.viewData.name}</p>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <LogHistory
              subModulename={"departments"}
              refrenceId={this.state.viewId}
            ></LogHistory>
          </Fragment>
        )}
      </div>
    );
  }
}

export default ViewDepartment;
